jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

});


// Timer
(function() {
    function initShopifyTimer() {
      let durationInSeconds = 5 * 3600 + 55 * 60 + 21;
      const displayElement = document.getElementById('shopify-coupon-countdown-timer');

      if (!displayElement) return;

      function renderTime() {
        let hours = Math.floor(durationInSeconds / 3600);
        let minutes = Math.floor((durationInSeconds % 3600) / 60);
        let seconds = durationInSeconds % 60;

        let hoursFormatted = hours < 10 ? '0' + hours : hours;
        let minutesFormatted = minutes < 10 ? '0' + minutes : minutes;
        let secondsFormatted = seconds < 10 ? '0' + seconds : seconds;

        displayElement.textContent = `${hoursFormatted}:${minutesFormatted}:${secondsFormatted}`;
      }

      function tick() {
        if (durationInSeconds <= 0) {
          clearInterval(timerInterval);
          displayElement.textContent = "00:00:00";
          return;
        }
        durationInSeconds--;
        renderTime();
      }

      renderTime();
      const timerInterval = setInterval(tick, 1000);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initShopifyTimer);
    } else {
      initShopifyTimer();
    }

    document.addEventListener('shopify:section:load', initShopifyTimer);
  })();


  // Product info
 (function () {
        function setupLayoutInteractions() {
            window.switchDesktopTab = function (event, tabId) {
                const panels = document.querySelectorAll('.tab-panel-desktop');
                panels.forEach(panel => panel.classList.remove('active'));

                const buttons = document.querySelectorAll('.tabs-nav-desktop .tab-button');
                buttons.forEach(button => button.classList.remove('active'));

                document.getElementById(tabId).classList.add('active');
                event.currentTarget.classList.add('active');
            };

            window.toggleMobileAccordion = function (itemId) {
                const item = document.getElementById(itemId);
                if (!item) return;

                const isActive = item.classList.contains('active');
                item.classList.toggle('active', !isActive);
            };
        }

        setupLayoutInteractions();
        document.addEventListener('shopify:section:load', setupLayoutInteractions);
    })();



  